/**
 * 如无非常必要!!,不在此添加全局内容,控制vendor最小化,最大不超过200k
 */
import './_config';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { _$eruda, _$windowFontSize } from '@/utils/index';
import '@/utils/log';
import Router from 'vue-router';
//import '@yq/mobile-blibs/lib/mobile-blibs.css';

Vue.use(Router);
Vue.prototype.$echarts = () =>
    window.echarts
        ? Promise.resolve(window.echarts)
        : new Promise((r, j) => {
              document.body.appendChild(
                  Object.assign(document.createElement('script'), {
                      type: 'text/javascript',
                      src: 'https://cdn-cnc.17zuoye.cn/s17/lib/echarts/5.3.0/echarts.min.js',
                      onload: r,
                      onerror: j,
                  })
              );
          }).then(() => window.echarts);
import installDirective from '@/directive';
// 原型中添加catch捕获error
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => err);
};
/**
 * 安装全局指令
 */
installDirective(Vue);
Vue.config.productionTip = false;
_$windowFontSize();
_$eruda(() => {
    new Vue({
        router,
        store,
        render: (h) => h(App),
    }).$mount('#app');
});
